import { createRoutine } from 'redux-saga-routines';

export const fetchMetadata = createRoutine('FETCH_METADATA');
export const connectGmail = createRoutine('CONNECT_GMAIL');
export const reconnectGmail = createRoutine('RECONNECT_GMAIL');
export const disconnectGmail = createRoutine('DISCONNECT_GMAIL');
